/* eslint-disable */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MessageComposer from 'components/MessageComposer';
import { JobChatMessageThread } from '@icimscorp/mui-acs';
import { Box } from '@material-ui/core';
import Transition from 'components/Transition';
import { initializeAnonWithFirstMessage } from 'redux/actions';
import { AppMessenger, ariConfig } from 'utils';
import { useAddIntroMessage } from './useAddIntroMessage';
import { USER_INPUT_ACTION } from 'widgetActions';

export default function SpoofedChatView() {
  const dispatch = useDispatch();
  const [goToTransitionUI, setGotToTransitionUI] = React.useState(false);
  const { messages, initialAriMessageObj, isSendingMsg } = useSelector((state) => state.appReducer);
  const [localMsgs, setLocalMsgs] = React.useState(messages);
  const [isAwaitingResponse, setIsAwaitingResponse] = React.useState(false);

  /**
   * After initializeAnonWithFirstMessage is fulfilled:
   * 1. Emit event to job chat widget - this is used by GA4 team to capture user activities
   * 2. Render the Transition UI - this UI will be a waiting period for user until job chat is open for communication
   */
  const initializeCallback = () => {
    AppMessenger.sendMessageToWidget({ action: USER_INPUT_ACTION });
    setGotToTransitionUI(true);
  };

  /**
   * Initialize job-chat session with candidate's text, and
   * Redirect to Transition UI
   */
  const initiateChatAndSendMsg = (text) => {
    const msg = text.trim();
    if (msg) {
      dispatch(initializeAnonWithFirstMessage({ text: msg, callback: initializeCallback }));
    }
  };

  useAddIntroMessage(localMsgs, initialAriMessageObj, setLocalMsgs);

  React.useEffect(() => {
    const lastMsg = localMsgs[localMsgs.length - 1];

    if (lastMsg) {
      setIsAwaitingResponse(lastMsg.type === 0);
    }
  }, [localMsgs]);

  if (goToTransitionUI) {
    return <Transition />;
  }

  return (
    <Box height="100%" display="flex" flexDirection="column">
      <JobChatMessageThread
        messages={localMsgs}
        ariCustomData={{
          displayName: ariConfig.displayName,
          imgUrl: ariConfig.imgUrl,
          imgAlt: ariConfig.imgAlt,
        }}
        fileUploadCallback={() => {}}
        isAwaitingResponse={isAwaitingResponse}
      />
      <MessageComposer
        handleSend={({ text }) => initiateChatAndSendMsg(text)}
        isSendingMsg={isSendingMsg}
      />
    </Box>
  );
}
